/**
 * Deterministic fallback for an <Img> whose `imageKey` is missing from the
 * manifest: pick an existing manifest key sharing the same "family" prefix
 * (the text before the first "-", e.g. "p", "a", "c", "f", "i", "pdp", "hero").
 * Returns null when no manifest key shares that family (render placeholder only).
 */

export function familyOf(key: string): string {
  const dashIndex = key.indexOf("-");
  return dashIndex === -1 ? key : key.slice(0, dashIndex);
}

/** Simple deterministic string hash (djb2) — stable across runs/platforms. */
export function stableHash(input: string): number {
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 33) ^ input.charCodeAt(i);
  }
  return hash >>> 0;
}

export function resolveImageKey(imageKey: string, manifestKeys: readonly string[]): string | null {
  if (manifestKeys.includes(imageKey)) return imageKey;

  const family = familyOf(imageKey);
  const candidates = manifestKeys.filter((key) => familyOf(key) === family).toSorted();
  if (candidates.length === 0) return null;

  const index = stableHash(imageKey) % candidates.length;
  return candidates[index] ?? null;
}
